export default class FilterToggleHtml {
    constructor(buttonText, contentHeadline, content) {
        this._buttonText = buttonText;
        this._contentHeadline = contentHeadline;
        this._content = content;
    }

    toString() {
        return `
            <div class="rfct-filter-toggle">
                <div class="rfct-filter-toggle__button-container">
                    <button class="rfct-button rfct-button--secondary">
                        <span class="rfct-button__inner">
                            <span class="rfct-button__label">${this._buttonText}</span>
                            <span class="rfct-button__icon material-icons">
                                filter_list
                            </span>
                        </span>
                    </button>
                </div>
                <div class="rfct-filter-toggle__content">
                    <div class="rfct-filter-toggle__content-head">
                        <strong class="rfct-filter-toggle__content-headline">${this._contentHeadline}</strong>
                        <button class="rfct-filter-toggle__close-button">
                            <span class="rfct-filter-toggle__close-icon material-icons">close</span>
                        </button>
                    </div>
                    <div class="rfct-filter-toggle__content-body">
                        ${this._content}
                    </div>
                </div>
            </div>`;
    }
}
